import { render, staticRenderFns } from "./RegisterCoProducersTools.vue?vue&type=template&id=f91797e2&scoped=true&"
import script from "./RegisterCoProducersTools.vue?vue&type=script&lang=js&"
export * from "./RegisterCoProducersTools.vue?vue&type=script&lang=js&"
import style0 from "./RegisterCoProducersTools.vue?vue&type=style&index=0&id=f91797e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f91797e2",
  null
  
)

export default component.exports